import React from 'react';
import { IonItem, IonLabel, IonText } from '@ionic/react';
import type { ColorSelectionListRowProps } from 'features/shared/inventory/selections/color-selections/types/ColorSelectionListRowProps';
import 'features/shared/inventory/selections/color-selections/components/ColorSelectionListRowMobile.scss';

const na = (val: string) => (val.trim() !== '' ? val.trim() : 'N/A');

/**
 * Mobile colors row — same fields as {@link ColorSelectionListRowDesktop}.
 */
const ColorSelectionListRowMobile: React.FC<ColorSelectionListRowProps> = ({
  title
}) => {
  return (
    <IonItem lines="none" className="hk-mobile-color-selection-row">
      <IonLabel className="hk-mobile-color-selection-row-body">
        <IonText className="hk-mobile-color-selection-row-name">
          <p>{na(title)}</p>
        </IonText>
      </IonLabel>
    </IonItem>
  );
};

export default ColorSelectionListRowMobile;
